module.exports = __webpack_public_path__ + "static/media/orangemask.c53aa02b.svg";